import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useNotification } from './NotificationProvider';

const NotificationContainer: React.FC = () => {
  const { notifications } = useNotification();

  const getNotificationStyles = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-[#4caf50] border-[#4caf50] text-white font-sans text-lg';
      case 'savesuccess':
        return 'bg-black text-white';
      case 'error':
        return 'bg-red text-white';
      case 'warning':
        return 'bg-yellow-500 text-black';
      default:
        return 'bg-blue-500 text-white';
    }
  };

  return (
    <div className="fixed bottom-4 left-1/2 z-[9999] -translate-x-1/2 space-y-2">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 300, scale: 0.3 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 300, scale: 0.5, transition: { duration: 0.2 } }}
            className={`max-w-md min-w-[300px] rounded-lg p-4 shadow-lg ${getNotificationStyles(notification.type)}`}
          >
            <span className="text-sm font-medium">{notification.message}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default NotificationContainer;
